import React from "react";
import { graphql } from "gatsby";
import PartnersTemplate from "@components/partnersPage/partnersTemplate";

const IndexPage = ({
  data: {
    prismic: {
      allPartnerss: {
        edges: {
          0: { node: partnersData },
        },
      },
    },
  },
  pageContext,
}) => <PartnersTemplate data={partnersData} pageContext={pageContext} />;

export const query = graphql`
  query AllPartners($localeCode: String) {
    prismic {
      allPartnerss(lang: $localeCode) {
        edges {
          node {
            partners {
              partnerLink {
                ... on PRISMIC__ExternalLink {
                  url
                }
              }
              partnerDescription
              partnerName
              partnerPhoto
            }
            partnersHeroHeading
            partnersHeroImage
            partnersHeroSubheading
            partnersCtaTitle
            partnersCtaText
            partnersCtaSubtitle
            partnersCtaLink {
              ... on PRISMIC__ExternalLink {
                url
              }
            }
          }
        }
      }
    }
  }
`;

export default IndexPage;
